import { GameroomEvent } from '@/redux/types/room'

export const AUTO_RELEASE_CHOOSE_EVENT_LABEL = 'Choose Event'

export function getAutoReleaseEventTitles(
  eventIds: number[] | undefined,
  events: GameroomEvent[]
): string[] {
  return (eventIds ?? [])
    .map((id) => events.find((e) => e.id === id)?.title)
    .filter((t): t is string => !!t)
}

export function getAutoReleaseDropdownLabel(
  eventIds: number[] | undefined,
  events: GameroomEvent[]
): string {
  const titles = getAutoReleaseEventTitles(eventIds, events)
  if (titles.length === 0) return AUTO_RELEASE_CHOOSE_EVENT_LABEL
  if (titles.length === 1) return titles[0]
  return `${titles[0]} +${titles.length - 1}`
}
